export default __webpack_public_path__ + "static/media/blog-1.c1c2e338.jpg";